import { arcadeApiClient } from '../apiClients'
import useSWR from 'swr'

export interface SelectableManagedUser {
  id: number
  email: string
  name: string
}

const usersFetcher = async (
  endpoint,
): Promise<{ managedUsers: SelectableManagedUser[] }> => {
  return arcadeApiClient.get(endpoint).then(res => res.data)
}

/*
  This hook returns the users that the current user manages. This should be used in places where we need
  minimal user information (id, email, name) for dropdowns, selects, and filters.
*/
export const useSelectableManagedUsers = () => {
  const { data, isValidating, error } = useSWR(
    '/multi_platform/select/managed_users',
    usersFetcher,
  )

  return {
    users: data?.managedUsers as SelectableManagedUser[],
    loading: isValidating,
    error,
  }
}
